<template>
  <Combobox
    :groups="dates"
    :name="name"
    :triggerLabel="name"
    :handle="handle"
    type="date"
  />
</template>

<script setup>
// Libraries
import { computed, ref } from "vue";

// Components
import { Combobox } from "@/SharedComponents/Filters/Combobox";

// Composables
import { useDateShortcuts } from "@/SharedComponents/Date";

// Props
defineProps({
  name: {
    type: String,
    required: true,
  },
});

// Refs
const handle = ref("purchased_date");

// Imported functions
const { purchasedDateShortcuts } = useDateShortcuts();

// Computed props
const dates = computed(() => {
  return [
    {
      options: purchasedDateShortcuts.map((date) => {
        let { name, ...other } = date;
        return { label: name, ...other };
      }),
    },
  ];
});
</script>
